import styled from '@emotion/styled';

import { materialTheme } from '../../particles/theme';

const StyledSuperAdmin = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background-color: ${materialTheme.palette.background.default};

  .sidebar {
    height: 100%;
    flex-shrink: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
  }

  .header {
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    flex-shrink: 0;
    z-index: 1;
  }

  .main {
    flex: 1;
    min-height: 0;
    margin: 0 10px 10px 10px;
    background-color: ${materialTheme.palette.background.paper};
    overflow-x: auto;
    overflow-y: auto;
  }
`;

export default StyledSuperAdmin;
